function GetTargetDate(weekNum, deadline, year) {
    let startDate;
    let endDate;

    if (year === '2022') {
        if(weekNum === 2){
            startDate = new Date(2024, 8, 13);
            endDate = new Date(2024, 8, 20);
        } else if(weekNum === 3){
            startDate = new Date(2022, 8, 20);
            endDate = new Date(2022, 8, 27);
        } else if(weekNum === 4){
            startDate = new Date(2022, 8, 27);
            endDate = new Date(2022, 9, 4);
        } else if(weekNum === 5){
            startDate = new Date(2022, 9, 4);
            endDate = new Date(2022, 9, 11);
        } else if(weekNum === 6){
            startDate = new Date(2022, 9, 11);
            endDate = new Date(2022, 9, 18);
        } else if(weekNum === 7){
            startDate = new Date(2022, 9, 18);
            endDate = new Date(2022, 9, 25);
        } else if(weekNum === 8){
            startDate = new Date(2022, 9, 25);
            endDate = new Date(2022, 10, 1);
        } else if(weekNum === 9){
            startDate = new Date(2022, 10, 1);
            endDate = new Date(2022, 10, 8);
        } else if(weekNum === 10){
            startDate = new Date(2022, 10, 8);
            endDate = new Date(2022, 10, 15);
        } else if(weekNum === 11){
            startDate = new Date(2022, 10, 15);
            endDate = new Date(2022, 10, 22);
        } else if(weekNum === 12){
            startDate = new Date(2022, 10, 22);
            endDate = new Date(2022, 10, 29);
        } else if(weekNum === 13){
            startDate = new Date(2022, 10, 29);
            endDate = new Date(2022, 11, 6);
        } else if(weekNum === 14){
            startDate = new Date(2022, 11, 6);
            endDate = new Date(2022, 11, 13);
        } else if(weekNum === 15){
            startDate = new Date(2022, 11, 13);
            endDate = new Date(2022, 11, 20);
        } else if(weekNum === 16){
            startDate = new Date(2022, 11, 20);
            endDate = new Date(2022, 11, 27);
        } else if(weekNum === 17){
            startDate = new Date(2022, 11, 27);
            endDate = new Date(2023, 0, 3);
        } else if(weekNum === 18){
            startDate = new Date(2023, 0, 3);
            endDate = new Date(2023, 0, 10);
        } else {
            startDate = new Date(2022, 8, 6);
            endDate = new Date(2022, 8, 13);
        }
    
        while (startDate <= endDate) {
            if(weekNum !== 16 && (deadline.includes('normal') || deadline === 'london' || deadline === 'mnf') && startDate.getDay() === 0) {
                break;
            } else if((deadline === 'tnf' || deadline.includes('thanksgiving')) && startDate.getDay() === 4) {
                break;
            } else if((weekNum === 16 || deadline.includes('saturday')) && startDate.getDay() === 6) {
                break;
            }
            startDate.setDate(startDate.getDate() + 1);
        }
    
        return startDate;
    }

    if (year === '2023') {
        if(weekNum === 2){
            startDate = new Date(2023, 8, 12);
            endDate = new Date(2023, 8, 19);
        } else if(weekNum === 3){
            startDate = new Date(2023, 8, 19);
            endDate = new Date(2023, 8, 26);
        } else if(weekNum === 4){
            startDate = new Date(2023, 8, 26);
            endDate = new Date(2023, 9, 3);
        } else if(weekNum === 5){
            startDate = new Date(2023, 9, 3);
            endDate = new Date(2023, 9, 10);
        } else if(weekNum === 6){
            startDate = new Date(2023, 9, 10);
            endDate = new Date(2023, 9, 17);
        } else if(weekNum === 7){
            startDate = new Date(2023, 9, 17);
            endDate = new Date(2023, 9, 24);
        } else if(weekNum === 8){
            startDate = new Date(2023, 9, 24);
            endDate = new Date(2023, 9, 31);
        } else if(weekNum === 9){
            startDate = new Date(2023, 9, 31);
            endDate = new Date(2023, 10, 7);
        } else if(weekNum === 10){
            startDate = new Date(2023, 10, 7);
            endDate = new Date(2023, 10, 14);
        } else if(weekNum === 11){
            startDate = new Date(2023, 10, 14);
            endDate = new Date(2023, 10, 21);
        } else if(weekNum === 12){
            startDate = new Date(2023, 10, 21);
            endDate = new Date(2023, 10, 28);
        } else if(weekNum === 13){
            startDate = new Date(2023, 10, 28);
            endDate = new Date(2023, 11, 5);
        } else if(weekNum === 14){
            startDate = new Date(2023, 11, 5);
            endDate = new Date(2023, 11, 12);
        } else if(weekNum === 15){
            startDate = new Date(2023, 11, 12);
            endDate = new Date(2023, 11, 19);
        } else if(weekNum === 16){
            startDate = new Date(2023, 11, 19);
            endDate = new Date(2023, 11, 26);
        } else if(weekNum === 17){
            startDate = new Date(2023, 11, 26);
            endDate = new Date(2024, 0, 2);
        } else if(weekNum === 18){
            startDate = new Date(2024, 0, 2);
            endDate = new Date(2024, 0, 9);
        } else {
            startDate = new Date(2023, 8, 5);
            endDate = new Date(2023, 8, 12);
        }

        while (startDate <= endDate) {
            if((deadline.includes('normal') || deadline === 'london' || deadline === 'mnf') && startDate.getDay() === 0) {
                break;
            } else if((deadline === 'tnf' || deadline.includes('thanksgiving')) && startDate.getDay() === 4) {
                break;
            } 
            else if(deadline === 'black_friday' && startDate.getDay() === 5) {
                break;
            } else if(deadline.includes('saturday') && startDate.getDay() === 6) {
                break;
            }
            startDate.setDate(startDate.getDate() + 1);
        }

        return startDate;
    }

    if (year === '2024') {
        if(weekNum === 2){
            startDate = new Date(2024, 8, 10);
            endDate = new Date(2024, 8, 17);
        } else if(weekNum === 3){
            startDate = new Date(2024, 8, 17);
            endDate = new Date(2024, 8, 24);
        } else if(weekNum === 4){
            startDate = new Date(2024, 8, 24);
            endDate = new Date(2024, 9, 1);
        } else if(weekNum === 5){
            startDate = new Date(2024, 9, 1);
            endDate = new Date(2024, 9, 8);
        } else if(weekNum === 6){
            startDate = new Date(2024, 9, 8);
            endDate = new Date(2024, 9, 15);
        } else if(weekNum === 7){
            startDate = new Date(2024, 9, 15);
            endDate = new Date(2024, 9, 22);
        } else if(weekNum === 8){
            startDate = new Date(2024, 9, 22);
            endDate = new Date(2024, 9, 29);
        } else if(weekNum === 9){
            startDate = new Date(2024, 9, 29);
            endDate = new Date(2024, 10, 5);
        } else if(weekNum === 10){
            startDate = new Date(2024, 10, 5);
            endDate = new Date(2024, 10, 12);
        } else if(weekNum === 11){
            startDate = new Date(2024, 10, 12);
            endDate = new Date(2024, 10, 19);
        } else if(weekNum === 12){
            startDate = new Date(2024, 10, 19);
            endDate = new Date(2024, 10, 26);
        } else if(weekNum === 13){
            startDate = new Date(2024, 10, 26);
            endDate = new Date(2024, 11, 3);
        } else if(weekNum === 14){
            startDate = new Date(2024, 11, 3);
            endDate = new Date(2024, 11, 10);
        } else if(weekNum === 15){
            startDate = new Date(2024, 11, 10);
            endDate = new Date(2024, 11, 17);
        } else if(weekNum === 16){
            startDate = new Date(2024, 11, 17);
            endDate = new Date(2024, 11, 24);
        } else if(weekNum === 17){
            startDate = new Date(2024, 11, 24);
            endDate = new Date(2024, 11, 31);
        } else if(weekNum === 18){
            startDate = new Date(2024, 11, 31);
            endDate = new Date(2025, 0, 7);
        } else {
            startDate = new Date(2024, 8, 3);
            endDate = new Date(2024, 8, 10);
        }

        while (startDate <= endDate) {
            if((deadline.includes('normal') || deadline === 'london' || deadline === 'mnf') && startDate.getDay() === 0) {
                break;
            } else if((deadline === 'tnf' || deadline.includes('thanksgiving')) && startDate.getDay() === 4) {
                break;
            } 
            else if((deadline === 'black_friday' || deadline === 'friday_night') && startDate.getDay() === 5) {
                break;
            } else if(deadline.includes('saturday') && startDate.getDay() === 6) {
                break;
            }
            startDate.setDate(startDate.getDate() + 1);
        }

        return startDate;
    }

    if(weekNum === 2){
        startDate = new Date(2025, 8, 9);
        endDate = new Date(2025, 8, 16);
    } else if(weekNum === 3){
        startDate = new Date(2025, 8, 16);
        endDate = new Date(2025, 8, 23);
    } else if(weekNum === 4){
        startDate = new Date(2025, 8, 23);
        endDate = new Date(2025, 8, 30);
    } else if(weekNum === 5){
        startDate = new Date(2025, 8, 30);
        endDate = new Date(2025, 9, 7);
    } else if(weekNum === 6){
        startDate = new Date(2025, 9, 7);
        endDate = new Date(2025, 9, 14);
    } else if(weekNum === 7){
        startDate = new Date(2025, 9, 14);
        endDate = new Date(2025, 9, 21);
    } else if(weekNum === 8){
        startDate = new Date(2025, 9, 21);
        endDate = new Date(2025, 9, 28);
    } else if(weekNum === 9){
        startDate = new Date(2025, 9, 28);
        endDate = new Date(2025, 10, 4);
    } else if(weekNum === 10){
        startDate = new Date(2025, 10, 4);
        endDate = new Date(2025, 10, 11);
    } else if(weekNum === 11){
        startDate = new Date(2025, 10, 11);
        endDate = new Date(2025, 10, 18);
    } else if(weekNum === 12){
        startDate = new Date(2025, 10, 18);
        endDate = new Date(2025, 10, 25);
    } else if(weekNum === 13){
        startDate = new Date(2025, 10, 25);
        endDate = new Date(2025, 11, 2);
    } else if(weekNum === 14){
        startDate = new Date(2025, 11, 2);
        endDate = new Date(2025, 11, 9);
    } else if(weekNum === 15){
        startDate = new Date(2025, 11, 9);
        endDate = new Date(2025, 11, 16);
    } else if(weekNum === 16){
        startDate = new Date(2025, 11, 16);
        endDate = new Date(2025, 11, 23);
    } else if(weekNum === 17){
        startDate = new Date(2025, 11, 23);
        endDate = new Date(2025, 11, 30);
    } else if(weekNum === 18){
        startDate = new Date(2025, 11, 30);
        endDate = new Date(2026, 0, 6);
    } else {
        startDate = new Date(2025, 8, 2);
        endDate = new Date(2025, 8, 9);
    }

    while (startDate <= endDate) {
        if((deadline.includes('normal') || deadline === 'london' || deadline === 'mnf') && startDate.getDay() === 0) {
            break;
        } else if((deadline === 'tnf' || deadline.includes('thanksgiving')) && startDate.getDay() === 4) {
            break;
        } 
        else if((deadline === 'black_friday' || deadline === 'friday_night' || deadline.includes('christmas')) && startDate.getDay() === 5) {
            break;
        } else if(deadline.includes('saturday') && startDate.getDay() === 6) {
            break;
        }
        startDate.setDate(startDate.getDate() + 1);
    }

    return startDate;    

}

export default GetTargetDate;